import { STRIPE_PUBLISHABLE_KEY } from '@modules/config';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default stripePromise;
